// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"UJ-z","carouselContainer":"VJ-z"};